<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" @onSearch="onSearch" @onReset="onReset" @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`运单列表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

// let fromPath = null

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      breadcrumb: [
        { name: "财务管理", path: `/finance/accounts` },
        { name: "合同账款管理", path: `/finance/accounts` },
        { name: "车辆列表", path: `/finance/carlist` },
        { name: "运单列表" },
      ],
      formInline: {
        order_type: 2,
        ischeck: 1,
        isstatus: 4,
      },
      formCtrl: [
        // {
        //   ...this.ctrls.fleet,
        //   options: [],
        // },
      ],
      searchDateOptions: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { keyName: "predict_unloading_date", label: "卸货日期", },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 140 },
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "name", label: "货物名称", minwidth: 150 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 150 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 150 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, label: "卸货日期", minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', width: 140 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "公司运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', width: 110 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "repaytime", label: "预计结款日期", minwidth: 120 },
      ],
      getTotalProperty: [
        "kuiton",
        "kuitotal",
        "additional_fees",
        'compen',
        'freight',
        'inton',
        'unton',
        'caton',
      ],
      baseParams: [
        'order_type',
        'ischeck',
        'isstatus',
        'license',
        'contractid',
      ],
    };
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    // fromPath = from.path
    // console.log(fromPath)
    next()
  },
  mounted() {
    // console.log(fromPath)
    if (this.$route.path.includes('contract')) {
      this.breadcrumb = [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "合同统计", path: '/contract/statistics' },
        { name: "运单列表" },
      ]
    }
    const { contractid } = this.$route.query
    this.breadcrumb[2].path += '?id=' + contractid
    // console.log(this.breadcrumb)
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .retrieval {
    .value {
      .el-input {
        width: 100px;
      }
    }
  }
}

.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}

/deep/ .el-form--inline {
  .item:nth-child(1) {
    margin-right: 10px;
  }

  .item:nth-child(2) {
    margin-right: 10px;
  }

  .item:nth-child(3) {
    margin-right: 10px;
  }

  .item:nth-child(4) {
    margin-right: 10px;
  }
}
</style>
